export const createYearList = (year1, year2) => {
  const yearStart = Math.max(year1, year2); // 큰 값부터 시작
  const yearEnd = Math.min(year1, year2);   // 작은 값까지

  const yearList = [];
  for (let year = yearStart; year >= yearEnd; year--) {
    yearList.push(year);
  }

  return yearList;
};